/**
 * @generated SignedSource<<e0d56bec33f5d382360c5f41c54ff17d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type UnifiedLearningCertificationSortField = "ACTIVE_DATE" | "EXPIRE_DATE" | "ID" | "IMAGE_URL" | "NAME" | "NAME_ABBR" | "PUBLIC_URL" | "STATUS" | "TYPE" | "%future added value";
export type UnifiedLearningCertificationStatus = "ACTIVE" | "EXPIRED" | "%future added value";
export type UnifiedLearningCertificationType = "BADGE" | "CERTIFICATION" | "STANDING" | "%future added value";
export type UnifiedSortDirection = "ASC" | "DESC" | "%future added value";
export type UnifiedLearningCertificationQuery$variables = {
  after?: string | null;
  first?: number | null;
  internalId?: string | null;
  sortDirection?: UnifiedSortDirection | null;
  sortField?: UnifiedLearningCertificationSortField | null;
  status?: UnifiedLearningCertificationStatus | null;
  type?: ReadonlyArray<UnifiedLearningCertificationType> | null;
  username?: string | null;
};
export type UnifiedLearningCertificationQuery$data = {
  readonly unified: {
    readonly unifiedProfile: {
      readonly aaid?: string | null;
      readonly extensions?: ReadonlyArray<{
        readonly errorType: string | null;
        readonly statusCode: number | null;
      }> | null;
      readonly id?: string;
      readonly identifier?: string | null;
      readonly learning?: {
        readonly certifications?: {
          readonly edges?: ReadonlyArray<{
            readonly cursor: string | null;
            readonly node: {
              readonly activeDate: string | null;
              readonly expireDate: string | null;
              readonly id: string;
              readonly imageUrl: string | null;
              readonly name: string | null;
              readonly nameAbbr: string | null;
              readonly publicUrl: string | null;
              readonly status: string | null;
            } | null;
          } | null> | null;
          readonly extensions?: ReadonlyArray<{
            readonly errorType: string | null;
            readonly statusCode: number | null;
          }> | null;
          readonly identifier?: string | null;
          readonly message?: string | null;
          readonly pageInfo?: {
            readonly endCursor: string | null;
            readonly hasNextPage: boolean | null;
            readonly hasPreviousPage: boolean | null;
            readonly startCursor: string | null;
          };
          readonly totalCount?: number | null;
        } | null;
        readonly extensions?: ReadonlyArray<{
          readonly errorType: string | null;
          readonly statusCode: number | null;
        }> | null;
        readonly id?: string;
        readonly identifier?: string | null;
        readonly message?: string | null;
      } | null;
      readonly message?: string | null;
    } | null;
  } | null;
};
export type UnifiedLearningCertificationQuery = {
  response: UnifiedLearningCertificationQuery$data;
  variables: UnifiedLearningCertificationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "internalId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sortDirection"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sortField"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "status"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "type"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "username"
},
v8 = [
  {
    "kind": "Variable",
    "name": "internalId",
    "variableName": "internalId"
  },
  {
    "kind": "Variable",
    "name": "unifiedProfileUsername",
    "variableName": "username"
  }
],
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "aaid",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "identifier",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "statusCode",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "errorType",
  "storageKey": null
},
v15 = {
  "kind": "InlineFragment",
  "selections": [
    (v11/*: any*/),
    (v12/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "UnifiedQueryErrorExtension",
      "kind": "LinkedField",
      "name": "extensions",
      "plural": true,
      "selections": [
        (v13/*: any*/),
        (v14/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "UnifiedQueryError",
  "abstractKey": null
},
v16 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "sortDirection",
    "variableName": "sortDirection"
  },
  {
    "kind": "Variable",
    "name": "sortField",
    "variableName": "sortField"
  },
  {
    "kind": "Variable",
    "name": "status",
    "variableName": "status"
  },
  {
    "kind": "Variable",
    "name": "type",
    "variableName": "type"
  }
],
v17 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "UnifiedLearningCertificationEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "cursor",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "UnifiedLearningCertification",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v9/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "activeDate",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "expireDate",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "imageUrl",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "nameAbbr",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "status",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "publicUrl",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "totalCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "UnifiedPageInfo",
      "kind": "LinkedField",
      "name": "pageInfo",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "endCursor",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "hasNextPage",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "hasPreviousPage",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "startCursor",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "UnifiedLearningCertificationConnection",
  "abstractKey": null
},
v18 = {
  "kind": "InlineFragment",
  "selections": [
    (v11/*: any*/),
    (v12/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "UnifiedQueryErrorExtension",
      "kind": "LinkedField",
      "name": "extensions",
      "plural": true,
      "selections": [
        (v14/*: any*/),
        (v13/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "UnifiedQueryError",
  "abstractKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "UnifiedLearningCertificationQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UnifiedQuery",
        "kind": "LinkedField",
        "name": "unified",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v8/*: any*/),
            "concreteType": null,
            "kind": "LinkedField",
            "name": "unifiedProfile",
            "plural": false,
            "selections": [
              {
                "kind": "InlineFragment",
                "selections": [
                  (v9/*: any*/),
                  (v10/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "learning",
                    "plural": false,
                    "selections": [
                      (v15/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v9/*: any*/),
                          {
                            "alias": null,
                            "args": (v16/*: any*/),
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "certifications",
                            "plural": false,
                            "selections": [
                              (v15/*: any*/),
                              (v17/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "UnifiedLearning",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "type": "UnifiedProfile",
                "abstractKey": null
              },
              (v18/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v7/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "UnifiedLearningCertificationQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UnifiedQuery",
        "kind": "LinkedField",
        "name": "unified",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v8/*: any*/),
            "concreteType": null,
            "kind": "LinkedField",
            "name": "unifiedProfile",
            "plural": false,
            "selections": [
              (v19/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v9/*: any*/),
                  (v10/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "learning",
                    "plural": false,
                    "selections": [
                      (v19/*: any*/),
                      (v15/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v9/*: any*/),
                          {
                            "alias": null,
                            "args": (v16/*: any*/),
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "certifications",
                            "plural": false,
                            "selections": [
                              (v19/*: any*/),
                              (v15/*: any*/),
                              (v17/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "UnifiedLearning",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "type": "UnifiedProfile",
                "abstractKey": null
              },
              (v18/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "d36f42335e35cc76807476a682354f7c",
    "id": null,
    "metadata": {},
    "name": "UnifiedLearningCertificationQuery",
    "operationKind": "query",
    "text": "query UnifiedLearningCertificationQuery(\n  $username: String\n  $after: String\n  $first: Int\n  $sortDirection: UnifiedSortDirection\n  $sortField: UnifiedLearningCertificationSortField\n  $status: UnifiedLearningCertificationStatus\n  $type: [UnifiedLearningCertificationType!]\n  $internalId: String\n) {\n  unified {\n    unifiedProfile(unifiedProfileUsername: $username, internalId: $internalId) {\n      __typename\n      ... on UnifiedProfile {\n        id\n        aaid\n        learning {\n          __typename\n          ... on UnifiedQueryError {\n            identifier\n            message\n            extensions {\n              statusCode\n              errorType\n            }\n          }\n          ... on UnifiedLearning {\n            id\n            certifications(first: $first, after: $after, status: $status, type: $type, sortField: $sortField, sortDirection: $sortDirection) {\n              __typename\n              ... on UnifiedQueryError {\n                identifier\n                message\n                extensions {\n                  statusCode\n                  errorType\n                }\n              }\n              ... on UnifiedLearningCertificationConnection {\n                edges {\n                  cursor\n                  node {\n                    id\n                    activeDate\n                    expireDate\n                    imageUrl\n                    name\n                    nameAbbr\n                    status\n                    publicUrl\n                  }\n                }\n                totalCount\n                pageInfo {\n                  endCursor\n                  hasNextPage\n                  hasPreviousPage\n                  startCursor\n                }\n              }\n            }\n          }\n        }\n      }\n      ... on UnifiedQueryError {\n        identifier\n        message\n        extensions {\n          errorType\n          statusCode\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "2ddf838318b1a5d4f843cda8b48d4e91";

export default node;
